'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxRouter = require('redux-router');

var _caligramReact = require('caligram-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeaturedListContainer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    events: state.featured.data
  };
}, { push: _reduxRouter.push }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FeaturedListContainer, _Component);

  function FeaturedListContainer() {
    (0, _classCallCheck3.default)(this, FeaturedListContainer);
    return (0, _possibleConstructorReturn3.default)(this, (FeaturedListContainer.__proto__ || (0, _getPrototypeOf2.default)(FeaturedListContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(FeaturedListContainer, [{
    key: 'render',
    value: function render() {
      var hasEvents = this.props.events.length > 0;
      var classNames = ['FeaturedListContainer'];
      if (!hasEvents) {
        classNames.push('empty');
      }

      return _react2.default.createElement(
        'div',
        { className: classNames.join(' ') },
        hasEvents ? this.props.children({ events: this.props.events }) : _react2.default.createElement('span', null)
      );
    }
  }]);
  return FeaturedListContainer;
}(_react.Component), _class2.propTypes = {
  children: _react.PropTypes.func,
  events: _react.PropTypes.array,
  push: _react.PropTypes.func.isRequired
}, _class2.defaultProps = {
  children: function children(props) {
    return _react2.default.createElement(_caligramReact.EventList, (0, _extends3.default)({ title: 'En vedette', layout: 'grid', groupBy: 'none', dateFormat: 'Do MMMM' }, props));
  }
}, _temp)) || _class);
exports.default = FeaturedListContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/FeaturedListContainer.js
// module id = 1182
// module chunks = 0